import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { faMessageLines } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function InterneNotizTooltip({
  interneNotiz,
}: {
  interneNotiz: string;
}) {
  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipContent className="max-w-80">{interneNotiz}</TooltipContent>
        <TooltipTrigger className="hover:cursor-default">
          <div className="hover:bg-neutrals-N300 p-1 rounded-md size-6 transition-all flex items-center justify-center">
            <FontAwesomeIcon
              icon={faMessageLines}
              className="text-primary-blue-B600"
            />
          </div>
        </TooltipTrigger>
      </Tooltip>
    </TooltipProvider>
  );
}
